import styles from "./OnlineStatementsTables.module.css";
import { Statement } from "../../../lib/api/models";
import { StatementByYear } from "../OnlineStatements.hooks";
import TextButton from "../../common/buttons/TextButton";

const strings = {
  noStatement: (month: string) => `No statement issued for ${month}`,
  inProcess: "Statement In Process",
  viewStatement: "View Statement",
};

type TableRowProps = Statement & {
  onOpenStatement: (statement: Statement) => Promise<void>;
};

function TableRow({ onOpenStatement, ...statement }: TableRowProps) {
  // If there is no statement for this month, print such
  if (!statement.isProcessing && statement.url === null) {
    const [month] = statement.title.split(" ");
    return (
      <tr>
        <td colSpan={2}>{strings.noStatement(month)}</td>
      </tr>
    );
  }
  return (
    <tr>
      <td>{statement.title}</td>
      <td>
        {statement.isProcessing ? (
          // If this statement is in process, print such
          <span className={styles.bold}>{strings.inProcess}</span>
        ) : (
          // Otherwise, show button to view statement URL
          <TextButton
            className={styles.link}
            // NOTE: We would never expect statement.url to be null given real data
            onClick={() => onOpenStatement(statement)}
          >
            {strings.viewStatement}
          </TextButton>
        )}
      </td>
    </tr>
  );
}

type TableProps = StatementByYear & {
  onOpenStatement: (statement: Statement) => Promise<void>;
};

function Table({ year, statements, onOpenStatement }: TableProps) {
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th colSpan={2}>{year}</th>
        </tr>
      </thead>
      <tbody>
        {statements.map((statement) => (
          <TableRow
            key={statement.statementDate}
            {...statement}
            onOpenStatement={onOpenStatement}
          />
        ))}
      </tbody>
    </table>
  );
}

type Props = {
  years: StatementByYear[];
  onOpenStatement: (statement: Statement) => Promise<void>;
};

export default function OnlineStatementsTables({
  years,
  onOpenStatement,
}: Props) {
  return years.map((item) => (
    <Table key={item.year} {...item} onOpenStatement={onOpenStatement} />
  ));
}
